module.exports = __webpack_public_path__ + "static/media/tutorial_atividades_complementares_aluno.836fa6c2.pdf";